import React, { useEffect, useState } from 'react'
import bwipjs from 'bwip-js';


const QRCodeGenerator = ({size, value}) => {
    let canvas = document.createElement('canvas');
    const [state, setState] = useState({
        imageURL: ""
    });
    const sep = String.fromCharCode(29);
    const temperature = value.temperature ? value.temperature : '0';
    const priority = value.priority ? value.priority.charAt(0) : 'F';
    const QRValue = value.mediavolume ? `91T${sep}92${value.mediavolume}${sep}93${(value.concentration * 10)}${sep}94${temperature}${sep}95${(value.dispinseflow * 1000)}${sep}96${priority}${sep}97${value.testname}${sep}98${value.desc}${sep}99READYSTREAM` : `91T${sep}92${value.volume}${sep}93${(value.concentration * 10)}${sep}94${temperature}${sep}95${(value.flowrate * 1000)}${sep}96${priority}${sep}97${value.testname}${sep}98${value.description}${sep}99READYSTREAM`;
    useEffect(() => {
         bwipjs(canvas, {
            bcid: 'datamatrix',
            text: QRValue,
            scale: 2,
            includetext: false,
            textxalign: 'center',
            rows: 48,
            columns: 48
        }, function (err, cvs) {
            if (err) {
                // Decide how to handle the error
                // `err` may be a string or Error object
            } else {
                setState({
                    imageURL: canvas.toDataURL('image/png')
                })
            }
        });
    }, [])
    return (
        <img src={state.imageURL} id="qrCodeImage" className="qr-code-image"/>
    )
}

export default QRCodeGenerator;